import { ref } from 'vue'
import axios from 'axios'
import { useCommon } from '../composable/useCommon.js'
const { cachedAxiosGet } = useCommon()

export function useGlobalHeader (devDomains) {
  const siteDomain = devDomains?.site || 'https://site.weathernews.jp'
  const getHeaderMenu = async () => {
    try {
      const { data } = await cachedAxiosGet(`${siteDomain}/site/global_header/header_menu_new.json`)
      return data
    } catch (error) {
      return []
    }
  }

  const addParams = (linkUrl, fmQuery) => {
    const url = new URL(linkUrl)
    url.searchParams.set('fm', fmQuery)
    return url.toString()
  }

  const searchQuery = ref(null)
  const searchResults = ref([])

  const searchCity = async (qword, lang) => {
    searchResults.value = []

    const url = new URL('https://weathernews.jp/onebox/api_search.cgi')
    url.searchParams.set('query', qword)
    url.searchParams.set('lang', lang)
    const result = await axios.get(url.toString()).then((res) => res.data)
    if (result.length === 1) {
      location.href = `https://weathernews.jp${result[0].url}&temp=c&lang=ja`
      return
    }
    const matchResult = result.find((res) => res.loc === qword)
    if (matchResult) {
      location.href = `https://weathernews.jp${matchResult[0].url}&temp=c&lang=ja`
      return
    }

    searchResults.value = result.map((res) => {
      res.url = `https://weathernews.jp${res.url}`
      return res
    })
  }

  const searchCityInput = (lang) => {
    if (searchQuery.value == null) return
    return searchCity(searchQuery.value, lang)
  }

  return {
    getHeaderMenu,
    addParams,
    searchQuery,
    searchResults,
    searchCityInput
  }
}
